import { getLocalConfig } from '../utils/LocalConfig';

export default class Utils {
  static getUrlEndpoint() {
      if (process.env.REACT_APP_ENV === 'local') {
          return getLocalConfig('REACT_APP_SOLR_ENDPOINT');
      }
      return process.env.REACT_APP_SOLR_ENDPOINT
  }

  static getEmptyStateBody() {
    if (process.env.REACT_APP_ENV === 'local') {
        return getLocalConfig('REACT_APP_EMPTY_STATE_BODY');
    }
    return process.env.REACT_APP_EMPTY_STATE_BODY
  }

  static getRedHatClient() {
    if (process.env.REACT_APP_ENV === 'local') {
      return getLocalConfig('REACT_APP_REDHAT_CLIENT');
    }

    return process.env.REACT_APP_REDHAT_CLIENT;
  }

  static getErrorStateContentLineTwo() {
    if (process.env.REACT_APP_ENV === 'local') {
        return getLocalConfig('REACT_APP_ERROR_STATE_CONTENT_LINE_TWO');
    }
    return process.env.REACT_APP_ERROR_STATE_CONTENT_LINE_TWO
  }

  static getHostUrl() {
    if (process.env.REACT_APP_ENV === 'local') {
      return getLocalConfig('REACT_APP_HOST_URL');
    }
  return process.env.REACT_APP_HOST_URL
    
  }

  static getSiteName() {
    if (process.env.REACT_APP_ENV === 'local') {
      return getLocalConfig('REACT_APP_SITE_NAME');
    }
  return process.env.REACT_APP_SITE_NAME
    
  }

  static getPageTitle() {
    if (process.env.REACT_APP_ENV === 'local') {
      return getLocalConfig('REACT_APP_PAGE_TITLE');
    }
  return process.env.REACT_APP_PAGE_TITLE
    
  }

  static getFnCalls() {
    if (process.env.REACT_APP_ENV === 'local') {
      return getLocalConfig('REACT_APP_FN_CALLS');
    }
  return process.env.REACT_APP_FN_CALLS
    
  }

  static generateFacetMapping(){
    let mapping = {};
    let facetKeys
    let facetNames
    let facetWeights
    if (process.env.REACT_APP_ENV === 'local') {
      facetKeys = getLocalConfig('REACT_APP_FACET_MAPPING_KEYS')?.split(",");
      facetNames = getLocalConfig('REACT_APP_FACET_MAPPING_NAMES')?.split(",");
      facetWeights = getLocalConfig('REACT_APP_FACET_MAPPING_WEIGHTS')?.split(",");

      for(let i = 0; i < facetKeys?.length; i++){
        mapping[facetKeys[i]] = {name: facetNames[i], weight: facetWeights[i]}
      }
    return mapping
    }
    facetKeys = process.env.REACT_APP_FACET_MAPPING_KEYS?.split(",");
    facetNames = process.env.REACT_APP_FACET_MAPPING_NAMES?.split(",");
    facetWeights = process.env.REACT_APP_FACET_MAPPING_WEIGHTS?.split(",");

    for(let i = 0; i < facetKeys?.length; i++){
      mapping[facetKeys[i]] = {name: facetNames[i], weight: facetWeights[i]}
    }
    return mapping
  }

  static getSearchFields() {
    if (process.env.REACT_APP_ENV === 'local') {
      return getLocalConfig('REACT_APP_SEARCH_FIELDS');
    }

    return process.env.REACT_APP_SEARCH_FIELDS;
  }

  static getViewUriOrigin(): string {
    if (process.env.REACT_APP_ENV === 'local') {
      return getLocalConfig('REACT_APP_VIEW_URI_ORIGIN');
    }

    return process.env.REACT_APP_VIEW_URI_ORIGIN || '';
  }

  static getFaceting(): Boolean {
    if (process.env.REACT_APP_ENV === 'local') {
      return getLocalConfig('REACT_APP_FACETING') === 'false' ? false : true;
    }

    return process.env.REACT_APP_FACETING === 'false' ? false : true;
  }

  static getAutoComplete(): Boolean {
    if (process.env.REACT_APP_ENV === 'local') {
      return getLocalConfig('REACT_APP_AUTOCOMPLETE') === 'false' ? false : true;
    }

    return process.env.REACT_APP_AUTOCOMPLETE === 'false' ? false : true;
  }
}
